// extracted by mini-css-extract-plugin
export default {"textarea":"styles_textarea__7oQCq"};